import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { createStackNavigator } from '@react-navigation/stack';
import { DocumentsSchemas } from '../schemas/documents';
import { DocumentsParamList } from '../typings/Params';
import { Module } from '../Routes';
import DocumentCategories from '../pages/documents/DocumentCategories/DocumentCategories';
import Documents from '../pages/documents/Documents/Documents';

export const documentsModule: Module<'Documents'> = {
    path: '/documents',
    stackNavigator: createStackNavigator<DocumentsParamList>(),
    canAccess: (user, currentApp) => Boolean(user && !currentApp.isAgentApp),
    icon: require('../../assets/icon_documents.png'),
    logo: require('../../assets/logo_documents.png'),
    label: 'documents',
    navigate: (navigation) => navigation.navigate('Documents'),
    schemas: DocumentsSchemas,
    screens: {
        DocumentsList: {
            path: 'documents-list',
            selectedItem: 'documents',
            component: Documents,
            label: 'documents',
            canAccess: (user) =>
                Boolean(
                    user?.permissions.documents_module_access
                    || user?.permissions.documents_manage_documents
                    || user?.permissions.documents_manage_all_acting_bodies_documents
                    || user?.permissions.documents_manage_acting_body_units_documents),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'DocumentsList' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        },
        DocumentCategories: {
            path: 'document-categories',
            selectedItem: 'document-categories',
            component: DocumentCategories,
            label: 'documentCategories',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_module_access
                    || user?.permissions.documents_manage_document_category
                    || user?.permissions.documents_manage_acting_body_units_document_category
                    || user?.permissions.documents_manage_all_acting_bodies_document_category),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'DocumentCategories' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        }
    },
};
